<template>
    <div class="all">
        <van-nav-bar
                title=""
                left-text="返回"
                right-text
                left-arrow
                @click-left="$goBack()"
        />
        <div></div>

        <div class="imgShow">
<!--            <img :src="u44">-->
            <p><strong>欢迎使用</strong></p>
        </div>

        <div class="login">
            <van-row>
                <van-col span="2">
                    <img :src="person">
                </van-col>
                <van-col span="16">
                    <van-field v-model="form.account" placeholder="请输入用户名"/>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="2">
                    <img :src="suo">
                </van-col>
                <van-col span="16">
                    <van-field v-model="form.pwd" type="passWord" placeholder="请输入密码"/>
                </van-col>
            </van-row>
            <p>
                <router-link :to="'/newPassword'">
                    忘记密码
                </router-link>
            </p>
        </div>

        <div class="buttom">
            <van-button size="lager" round @click="clickLogin()" :loading="submitLoading">登 陆</van-button>
            <p>
                <router-link :to="'/register'">
                    没有账号？免费注册
                </router-link>
            </p>
        </div>

    </div>
</template>

<script>
    import u44 from '@/assets/images/utui.jpg'
    import person1 from '@/assets/images/person1.png'
    import suo from '@/assets/images/suo.png'
    import store from '@/store'

    export default {
        data() {
            return {
                u44: u44,
                person: person1,
                suo: suo,
                form: {
                    account: '',
                    pwd: '',
                    loginType: 'pwd',
                },
                query: {
                    go: this.$route.query.go,
                },
                submitLoading:false
            }
        },
        methods: {
            clickLogin() {
                if (!this.$myUtil.isLegalPwd(this.form.pwd)) {
                    this.$toast("密码不正确")
                    return
                }
                this.submitLoading=true
                this.$http({
                    url: '/user/login',
                    method: 'post',
                    data: this.form
                }).then((result) => {
                    store.dispatch('removeToken')
                    store.dispatch('setToken', result.data)
                    let decodeUrlGo = decodeURIComponent(this.query.go)
                    this.$router.push(decodeUrlGo)
                }).catch((error) => {
                  this.submitLoading=false
                })

            },
            goMain(){
                this.$router.push('/main');
            }
        }
    }
</script>

<style lang="scss" scoped>
    * {
        margin: 0;
        padding: 0;
    }

    .all {
        background-color: #fff;
    }

    .imgShow {
        margin-bottom: 5rem;
        img {
            margin-top: 10%;
            margin-left: 40%;
            height: 6rem;
            width: 6rem;
        }
        p {
            margin-top: 10%;
            text-align: center;
            font-size: 1.6rem;
            color: #bfbfbf;
        }

    }

    .login {
        font-size: 1.2rem;
        .van-row {
            margin: 1rem 4rem;
            padding-bottom: 0.5rem;
            border-bottom: 1px solid #f2f2f2;
        }
        img {
            height: 1.5rem;
            width: 1.5rem;
        }
        input::-webkit-input-placeholder {
            margin-left: 1rem;
            color: #bfbfbf;
            font-size: 1.1rem;
        }
        p {
            margin: 1rem 4rem;
            text-align: right;
            font-size: 1.1rem;
            color: #8b8b8b;
        }
    }

    .buttom {
        .van-button {
            margin: 3rem;
            width: 80%;
            font-size: 1.2rem;
            background-color: #ee9900;
            color: #fff;
        }
        p {
            text-align: center;
            font-size: 1rem;
        }
    }
</style>
